/**
 * A tag's address opened signed out (/t/<code>): kept through the sign-in, and opened once the person is in a
 * company. Only tag addresses: every other page starts where the sign-in starts.
 */
const KEY = 'velanox.next'

export function keepNext(path: string): void {
  if (!path.startsWith('/t/')) return
  try { sessionStorage.setItem(KEY, path) } catch { /* the sign-in starts as usual */ }
}

/** the kept page, once: null when none */
export function takeNext(): string | null {
  try {
    const path = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return path?.startsWith('/t/') ? path : null
  } catch { return null }
}
